//export const LOGIN_USER = 'LOGIN_USER';
import axios from "axios";
import { authURL } from "../config";

export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const loginFail = () => {
  return { type: LOGIN_FAIL };
};
export const loginUserAction = user => {
  // console.log(user);
  return {
    type: LOGIN_USER_SUCCESS,
    user
  };
};
export const logout = () => {
  return {
    type: LOGOUT
  };
};

export const checkAuth = (token, ownProps) => {
  return dispatch =>
    axios
      .get(`${authURL}checkauth`, {
        headers: { authorization: token }
      })
      .then(res => {
        // console.log(res.data.loginDetails);
        dispatch(loginUserAction(res.data.loginDetails));
      })
      .catch(err => {
        dispatch(loginFail()) && ownProps.history.push("/signin");
      });
};
